import { render } from "./AdminTableActions.vue?vue&type=template&id=7347aafc&scoped=true"
import script from "./AdminTableActions.vue?vue&type=script&lang=js"
export * from "./AdminTableActions.vue?vue&type=script&lang=js"

import "./AdminTableActions.vue?vue&type=style&index=0&id=7347aafc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7347aafc"]])

export default __exports__